import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListView } from '../core/ListViewProvider'
import { useClienteAtual } from '../../empresasCliente-list/core/useClienteAtual'
import { RiscoColumns } from './columns/_columns'
import { RiscoAsoView } from '../core/_models'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

export const RiscoClienteTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { selected } = useListView()
  const cliente = useClienteAtual()
  const { t } = useT()

  const columns = useMemo(() => RiscoColumns(t), [t])

  return (
    <CustomTable<RiscoAsoView>
      id='kt_table_riscos_cliente'
      ariaLabel='Riscos'
      itemLabel={{ singular: 'risco', plural: 'riscos' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={
        <TableEmptyState
          title={
            cliente?.nome ? `Nenhum risco cadastrado em ${cliente.nome}` : 'Nenhum risco cadastrado'
          }
          description='Use “Adicionar” para cadastrar o primeiro risco por setor e cargo.'
        />
      }
      isRowSelected={(row) => selected.includes(row.id)}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
